import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import {
    CardFooterListItem,
    CardFooterListItemLink,
    ShowMoreArrowWrapper,
    ShowMoreLink,
    ShowMoreText,
} from 'src/domains/sportsbook/webview/components/racesSlider/shared/cardFooter/CardFooter.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ViewAllIcon } from 'src/domains/casino/webview/CasinoGames/home-games/slider/slider-header/SliderHeader.style';

export interface CardFooterPropsType {
    routingData: RacecardRaceRouteType;
}

export const CardFooter = observer('CardFooter', (props: CardFooterPropsType) => {
    const { routingData } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { raceCardVariant } = configState.componentVariants;
    if (raceCardVariant === DefaultComponentVariantType.SECONDARY) {
        return (
            <CardFooterListItemLink to={routingData}>
                <ShowMoreText>
                    <I18n
                        langKey='events.racebox.view.label'
                        defaultText='View racecard'
                    />
                    <ViewAllIcon />
                </ShowMoreText>
            </CardFooterListItemLink>
        );
    }
    return (
        <CardFooterListItem>
            <ShowMoreLink to={routingData}>
                <I18n
                    langKey='events.racebox.view.label'
                    defaultText='View racecard'
                />
                <ShowMoreArrowWrapper position='right' />
            </ShowMoreLink>
        </CardFooterListItem>
    );
});
